module.exports = __webpack_public_path__ + "static/media/frc-easter-image-2.d69eed4c.jpg";